import { render, staticRenderFns } from "./WorkflowVarietyBox.vue?vue&type=template&id=190e0c7e&scoped=true&"
import script from "./WorkflowVarietyBox.vue?vue&type=script&lang=js&"
export * from "./WorkflowVarietyBox.vue?vue&type=script&lang=js&"
import style0 from "./WorkflowVarietyBox.vue?vue&type=style&index=0&id=190e0c7e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "190e0c7e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!D:/Coding/farmerspace/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib'
import { VImg } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VProgressCircular } from 'vuetify/lib'
installComponents(component, {VFlex,VImg,VLayout,VProgressCircular})
